import classNames from 'classnames/bind';
import { ReactNode } from 'react';

import { useUpdatePriceChangesSubscription } from 'hooks/usePriceChangesSubscriptions';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface Props {
  changes: number[];
  children: ReactNode;
  clickCode: string;
  isDisabled: boolean;
  minPrice: number;
  searchKey: string;
  onCompleted(): void;
}

export default function UpdateButton({
  changes,
  children,
  clickCode,
  isDisabled,
  minPrice,
  searchKey,
  onCompleted,
}: Props) {
  const updatePriceChangesSubscription = useUpdatePriceChangesSubscription();

  function onError() {
    window.alert(
      '일시적인 오류로 가격 변동 알림을 설정할 수 없습니다.\n잠시 후 다시 시도해 주시기 바랍니다.',
    );
  }

  function onUpdate() {
    updatePriceChangesSubscription({
      variables: { subscription: { searchKey, changes, minPrice } },
      onCompleted,
      onError,
    });
  }

  return (
    <button
      type="button"
      className={cx('apply')}
      disabled={isDisabled}
      onClick={onUpdate}
      data-event-nlog="click"
      data-event-area-code={clickCode}
    >
      {children}
    </button>
  );
}
